import { stripePromise, getStripePriceId } from './stripe';
import { supabase } from './supabase';

// Interface for checkout options
export interface StripeCheckoutOptions {
  planId: string;
  businessId: string;
  customerEmail: string;
  successUrl: string;
  cancelUrl: string;
}

// Create Stripe checkout session
export const createStripeCheckoutSession = async (options: StripeCheckoutOptions) => {
  try {
    console.log('createStripeCheckoutSession called with options:', options);
    const { planId, businessId, customerEmail, successUrl, cancelUrl } = options;
    
    const priceId = getStripePriceId(planId);
    console.log('Price ID for plan:', { planId, priceId });
    
    if (!priceId) {
      throw new Error(`No Stripe price ID found for plan: ${planId}`);
    }
    
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    console.log('Calling Edge Function with payload:', {
      action: 'create-checkout',
      priceId,
      businessId,
      customerEmail,
      successUrl,
      cancelUrl,
      planId
    });
    
    const { data, error } = await supabase.functions.invoke('stripe-subscription', {
      body: {
        action: 'create-checkout',
        priceId,
        businessId,
        customerEmail,
        successUrl,
        cancelUrl,
        planId
      }
    });
    
    console.log('Edge Function response:', { data, error });
    
    if (error) {
      console.error('Error creating checkout session:', error);
      throw new Error('Failed to create checkout session');
    }
    
    if (!data?.sessionId) {
      console.error('No session ID returned:', data);
      throw new Error('No session ID returned from checkout creation');
    }
    
    console.log('Session ID received:', data.sessionId);
    
    const stripe = await stripePromise;
    if (!stripe) {
      throw new Error('Stripe not initialized');
    }
    
    console.log('Redirecting to Stripe checkout...');
    const { error: checkoutError } = await stripe.redirectToCheckout({ sessionId: data.sessionId });
    
    if (checkoutError) {
      console.error('Stripe checkout error:', checkoutError);
      throw new Error('Failed to redirect to checkout');
    }
    
    console.log('Successfully redirected to Stripe checkout');
    return { success: true };
  } catch (error) {
    console.error('Stripe checkout error:', error);
    throw error;
  }
};

// Handle successful Stripe checkout
export const handleStripeCheckoutSuccess = async (sessionId: string) => {
  try {
    console.log('handleStripeCheckoutSuccess called with sessionId:', sessionId);
    
    if (!supabase) {
      throw new Error('Supabase client not initialized');
    }
    
    console.log('Calling Edge Function to verify session...');
    const { data, error } = await supabase.functions.invoke('stripe-subscription', {
      body: {
        action: 'verify-session',
        sessionId
      }
    });
    
    console.log('Session verification response:', { data, error });
    
    if (error) {
      console.error('Error verifying session:', error);
      throw new Error('Failed to verify checkout session');
    }
    
    console.log('Session verified successfully:', data);
    return data;
  } catch (error) {
    console.error('Session verification error:', error);
    throw error;
  }
}; 